import { render, staticRenderFns } from "./infoNoticias.vue?vue&type=template&id=7c7c6242&scoped=true&"
import script from "./infoNoticias.vue?vue&type=script&lang=js&"
export * from "./infoNoticias.vue?vue&type=script&lang=js&"
import style0 from "./infoNoticias.vue?vue&type=style&index=0&id=7c7c6242&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7c6242",
  null
  
)

export default component.exports